import { useEffect } from 'react';
import RightsModal from '@/containers/rights-modal';
import { IMicroAppProps, INoticeData } from '@/types';
import { getGlobalStore } from '@/store/global';

const MicroComponents = ({ microAppType, onReceiveMessageFromMicroApp, registryNoticeMicroAppFn }: IMicroAppProps) => {
    useEffect(() => {
        const { publish, subscribe } = getGlobalStore()!;
        if (onReceiveMessageFromMicroApp) {
            subscribe('main-app', onReceiveMessageFromMicroApp);
            publish('main-app', { type: 'success', content: '通信已建立' });
        }
        registryNoticeMicroAppFn!(({ type, params = {} }: INoticeData) => {
            switch (microAppType) {
                case 'RightsModal':
                    publish('RightsModal', { type, params });
                    break;
                default:
                    break;
            }
        });
    }, []);

    switch (microAppType) {
        case 'RightsModal':
            return <RightsModal />;
        default:
            return null;
    }
};

export default MicroComponents;
